import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import ModalVideo from "react-modal-video";
import Banner from "./Banner";
import { FaPlay } from "react-icons/fa";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";

const Hero = () => {
  const [isOpen, setOpen] = useState(false);
  const [showProcessing, setShowProcessing] = useState(false);
  const navigate = useNavigate();

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  return (
    <>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="20QUNgFIrK0"
        onClose={() => setOpen(false)}
      />

      <div className="relative pt-[150px] md:pt-[200px] lg:pt-[250px] bg-black text-white overflow-hidden bg-gradient-to-b from-black to-red-900 text-white min-h-screen">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center" data-aos="fade-up">
            <h2 className="text-4xl sm:text-5xl font-bold leading-tight">
              Leveraging{" "}
              <span className="text-red-500 relative inline-block">
                Artificial Intelligence
              </span>{" "}
              for local businesses
            </h2>
            <p className="text-lg mt-6 mb-12 mx-auto max-w-2xl">
              Simple, powerful, and built for your business. Try it free for 30
              days!
            </p>

            <div className="flex flex-row sm:flex-row justify-center items-center gap-4">
              <button
                onClick={handleregister}
                className="bg-red-600 hover:bg-red-700 transition text-white font-medium py-2 px-6 rounded-full w-[150px] h-[45px]"
              >
                {showProcessing ? (
                  <div className="flex items-center justify-center w-full h-full">
                    <ProcessingBar2 />
                  </div>
                ) : (
                  "Try Free Now"
                )}
              </button>
              <div
                role="button"
                onClick={() => setOpen(true)}
                className="flex items-center gap-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-12 h-12 rounded-full border border-white text-red-500">
                  <FaPlay />
                </div>
                <div className="text-left">
                  <span className="text-red-500 text-sm leading-none">
                    Watch
                  </span>
                  <strong className="text-white block leading-tight">
                    Intro video
                  </strong>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard Image */}
          <div className="relative mt-16 lg:mt-20" data-aos="fade-up">
            <div className="w-full max-w-6xl mx-auto">
              <img
                src="/media/dashboard.png"
                alt="media"
                className="w-full rounded-2xl shadow-lg"
              />
            </div>
          </div>

          {/* Banner Below */}
          <div className="mt-24 md:mt-20" data-aos="fade-up">
            <Banner />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
